import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, X, ArrowRight, Zap } from 'lucide-react';
import { apiClient } from '../../api/client';

const AvaMissesYouCard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    apiClient.request('/api/enhancements/ava-misses-you')
      .then(setData)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || !data?.show_message || dismissed) return null;

  return (
    <div data-testid="ava-misses-you-card" className="rounded-2xl overflow-hidden mb-4">
      <div className="bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600 p-5 relative">
        {/* Dismiss */}
        <button
          data-testid="dismiss-ava-misses-you"
          onClick={() => setDismissed(true)}
          className="absolute top-3 right-3 w-6 h-6 rounded-full bg-white/20 text-white/70 hover:bg-white/30 flex items-center justify-center transition-colors"
        >
          <X className="w-3.5 h-3.5" />
        </button>

        <div className="flex items-start gap-4">
          {/* AvA avatar placeholder */}
          <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white flex-shrink-0">
            <MessageCircle className="w-6 h-6" />
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <p className="text-sm font-bold text-white">{data.ava_name}</p>
              <span className="px-2 py-0.5 rounded-full bg-white/15 text-white/70 text-xs">{data.days_away}d away</span>
            </div>
            <p className="text-sm text-white/90 leading-relaxed mb-3">{data.message}</p>

            {/* Quick tip */}
            <div className="flex items-center gap-2 p-2 rounded-lg bg-white/10 mb-3">
              <Zap className="w-3.5 h-3.5 text-yellow-300 flex-shrink-0" />
              <p className="text-xs text-white/70">{data.quick_tip}</p>
            </div>

            <button
              data-testid="ava-misses-you-cta"
              onClick={() => navigate('/conversations')}
              className="px-4 py-2 rounded-lg bg-white text-violet-700 text-sm font-semibold hover:bg-white/90 transition-colors flex items-center gap-2"
            >
              Let&apos;s Practice <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AvaMissesYouCard;
